// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/airspace-reservation-zones.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/airspace-reservation-zones/airspace-reservation-zones.js';

mount([g0]);
